export const IFRAME_COMMS_MESSAGE_TYPE = '__embedded_comms__';
export const DASHBOARD_UI_FILTER_CONFIG_URL_PARAM_KEY: {
  [index: string]: any;
} = {
  visible: 'show_filters',
  expanded: 'expand_filters',
  native: 'native_filters',
};
